$(document).ready(function(){

	var play = $('[data-selector="video-play"]'),
        video = $('[data-selector="video-wrap"]'),
        close = $('[data-selector="video-close"]'),
        movie = "";


	// initial full height
    calcHeight();

    // on resize
    $(window).resize(function() {
        calcHeight();
    });

    // arrow down
    $('[href="#first-panel"]').on('click', function(e) {
        e.preventDefault();
        var scroll = $('[data-anchor="first-panel"]').offset().top - $('.rheader').outerHeight();
        $('html,body').animate({scrollTop: scroll}, 'slow');
    });

    // play video
    play.on('click', function(e) {
        e.preventDefault();
        movie = $(this).attr('data-movie');
        currentScrollOffset = $(window).scrollTop();
        openVideo();
    });

    // close video
    close.on('click', function() {
        closeVideo();
    });

    // close video
    $(document).on('keyup', function(e) {
        if (27 === e.keyCode && isVideoVisible()) {
            closeVideo();
        }
    });

    function calcHeight() {
        if($(window).height() > 500 && $(window).width() > 767) {
            var height = $(window).height() - $('.rheader').outerHeight();
            $('.full-height').css('height', height);
        }
    }

    function openVideo() {
        video.addClass('open');
        $('html,body').stop().animate({
            scrollTop: parseInt(video.offset().top, 10)
        }, 500, 'swing', function(){
            video.find('iframe').attr('src', movie);
        	$('html').css({overflow: 'hidden'});
        });
    }

    function closeVideo() {
        video.removeClass('open').find('iframe').attr('src', 'about:blank');
        $('html,body').stop().animate({
            scrollTop: currentScrollOffset
        }, 500, 'swing', function(){
            $('html').css({overflow: 'auto'});
        });
    }

    function isVideoVisible() {
        return $('iframe', video).attr('src') !== 'about:blank';
    }

    function resizeVideo() {
        if (isVideoVisible()) {
            if(video.offset()){
                $('html,body').stop().animate({
                    scrollTop: parseInt(video.offset().top, 10)
                }, 500);
            }
        }
    }
});